class Progress {
    public id: number;
    public id_pact: number;
    public date_payment: string;
    public value_payment: string;
    public means_payment: string;
    public pending_value_payment: string;
    public is_active: string;

    constructor(
        id: number,
        id_pact: number,
        date_payment: string,
        value_payment: string,
        means_payment: string,
        pending_value_payment: string,
        is_active: string,
    ) {
        this.id = id;
        this.id_pact = id_pact;
        this.date_payment = date_payment;
        this.value_payment = value_payment;
        this.means_payment = means_payment;
        this.pending_value_payment = pending_value_payment;
        this.is_active = is_active;
    }
}
export default Progress;